<div class="delete-acc-success">
    <img src="assets/mascot/Mascot_sad-Grey@2x.webp" alt="odaring mascot"/>
    <h1>{{ 'complete.delete.desc.1' | translate }}</h1>
    <p>{{ 'complete.delete.desc.3' | translate }}</p>
</div>
